import { Text, useResponsiveValue } from 'braid-design-system';
import type { ComponentProps, FC } from 'react';

type TextSize = ComponentProps<typeof Text>['size'];
type ResponsiveTextProps = {
  size: { mobile: TextSize; tabletAndDesktop: TextSize };
} & Omit<ComponentProps<typeof Text>, 'size'>;

export const ResponsiveText: FC<ResponsiveTextProps> = ({
  children,
  size,
  ...restProps
}) => {
  const isMobile = useResponsiveValue()({
    mobile: true,
    tablet: false,
  });

  if (isMobile) {
    return (
      <Text size={size.mobile} {...restProps}>
        {children}
      </Text>
    );
  }

  return (
    <Text size={size.tabletAndDesktop} {...restProps}>
      {children}
    </Text>
  );
};
